import { render, staticRenderFns } from "./TargetDict.vue?vue&type=template&id=160639a2&scoped=true&"
import script from "./TargetDict.vue?vue&type=script&lang=js&"
export * from "./TargetDict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160639a2",
  null
  
)

export default component.exports